<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-user icons"></i><span class="name">user</span>
                .icon-user
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-people icons"></i
                ><span class="name">people</span> .icon-people
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-user-female icons"></i
                ><span class="name">user-female</span> .icon-user-female
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-user-follow icons"></i
                ><span class="name">user-follow</span> .icon-user-follow
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-user-following icons"></i
                ><span class="name">user-following</span> .icon-user-following
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-user-unfollow icons"></i
                ><span class="name">user-unfollow</span> .icon-user-unfollow
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-login icons"></i
                ><span class="name">login</span> .icon-login
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-logout icons"></i
                ><span class="name">logout</span> .icon-logout
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-emotsmile icons"></i
                ><span class="name">emotsmile</span> .icon-emotsmile
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-phone icons"></i
                ><span class="name">phone</span> .icon-phone
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-call-end icons"></i
                ><span class="name">call-end</span> .icon-call-end
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-call-in icons"></i
                ><span class="name">call-in</span> .icon-call-in
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-call-out icons"></i
                ><span class="name">call-out</span> .icon-call-out
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-map icons"></i
                ><span class="name">map</span> .icon-map
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-location-pin icons"></i
                ><span class="name">location-pin</span> .icon-location-pin
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-direction icons"></i
                ><span class="name">direction</span> .icon-direction
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-directions icons"></i
                ><span class="name">directions</span> .icon-directions
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-compass icons"></i
                ><span class="name">compass</span> .icon-compass
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-layers icons"></i
                ><span class="name">layers</span> .icon-layers
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-menu icons"></i
                ><span class="name">menu</span> .icon-menu
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-list icons"></i
                ><span class="name">list</span> .icon-list
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-options-vertical icons"></i
                ><span class="name">options-vertical</span>
                .icon-options-vertical
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-options icons"></i
                ><span class="name">options</span> .icon-options
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-down icons"></i
                ><span class="name">arrow-down</span> .icon-arrow-down
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-left icons"></i
                ><span class="name">arrow-left</span> .icon-arrow-left
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-right icons"></i
                ><span class="name">arrow-right</span> .icon-arrow-right
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-up icons"></i
                ><span class="name">arrow-up</span> .icon-arrow-up
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-up-circle icons"></i
                ><span class="name">arrow-up-circle</span> .icon-arrow-up-circle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-left-circle icons"></i
                ><span class="name">arrow-left-circle</span>
                .icon-arrow-left-circle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-right-circle icons"></i
                ><span class="name">arrow-right-circle</span>
                .icon-arrow-right-circle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-arrow-down-circle icons"></i
                ><span class="name">arrow-down-circle</span>
                .icon-arrow-down-circle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-check icons"></i
                ><span class="name">check</span> .icon-check
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-clock icons"></i
                ><span class="name">clock</span> .icon-clock
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-plus icons"></i
                ><span class="name">plus</span> .icon-plus
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-minus icons"></i
                ><span class="name">minus</span> .icon-minus
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-close icons"></i
                ><span class="name">close</span> .icon-close
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-event icons"></i
                ><span class="name">event</span> .icon-event
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-exclamation icons"></i
                ><span class="name">exclamation</span> .icon-exclamation
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-organization icons"></i
                ><span class="name">organization</span> .icon-organization
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-trophy icons"></i
                ><span class="name">trophy</span> .icon-trophy
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-screen-smartphone icons"></i
                ><span class="name">screen-smartphone</span>
                .icon-screen-smartphone
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-screen-desktop icons"></i
                ><span class="name">screen-desktop</span> .icon-screen-desktop
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-plane icons"></i
                ><span class="name">plane</span> .icon-plane
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-notebook icons"></i
                ><span class="name">notebook</span> .icon-notebook
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-mustache icons"></i
                ><span class="name">mustache</span> .icon-mustache
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-mouse icons"></i
                ><span class="name">mouse</span> .icon-mouse
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-magnet icons"></i
                ><span class="name">magnet</span> .icon-magnet
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-energy icons"></i
                ><span class="name">energy</span> .icon-energy
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-disc icons"></i
                ><span class="name">disc</span> .icon-disc
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-cursor icons"></i
                ><span class="name">cursor</span> .icon-cursor
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-cursor-move icons"></i
                ><span class="name">cursor-move</span> .icon-cursor-move
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-crop icons"></i
                ><span class="name">crop</span> .icon-crop
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-chemistry icons"></i
                ><span class="name">chemistry</span> .icon-chemistry
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-speedometer icons"></i
                ><span class="name">speedometer</span> .icon-speedometer
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-shield icons"></i
                ><span class="name">shield</span> .icon-shield
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-screen-tablet icons"></i
                ><span class="name">screen-tablet</span> .icon-screen-tablet
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-magic-wand icons"></i
                ><span class="name">magic-wand</span> .icon-magic-wand
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-hourglass icons"></i
                ><span class="name">hourglass</span> .icon-hourglass
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-graduation icons"></i
                ><span class="name">graduation</span> .icon-graduation
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-ghost icons"></i
                ><span class="name">ghost</span> .icon-ghost
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-game-controller icons"></i
                ><span class="name">game-controller</span> .icon-game-controller
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-fire icons"></i
                ><span class="name">fire</span> .icon-fire
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-eyeglass icons"></i
                ><span class="name">eyeglass</span> .icon-eyeglass
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-envelope-open icons"></i
                ><span class="name">envelope-open</span> .icon-envelope-open
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-envelope-letter icons"></i
                ><span class="name">envelope-letter</span> .icon-envelope-letter
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-bell icons"></i
                ><span class="name">bell</span> .icon-bell
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-badge icons"></i
                ><span class="name">badge</span> .icon-badge
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-anchor icons"></i
                ><span class="name">anchor</span> .icon-anchor
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-wallet icons"></i
                ><span class="name">wallet</span> .icon-wallet
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-vector icons"></i
                ><span class="name">vector</span> .icon-vector
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-speech icons"></i
                ><span class="name">speech</span> .icon-speech
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-puzzle icons"></i
                ><span class="name">puzzle</span> .icon-puzzle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-printer icons"></i
                ><span class="name">printer</span> .icon-printer
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-present icons"></i
                ><span class="name">present</span> .icon-present
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-playlist icons"></i
                ><span class="name">playlist</span> .icon-playlist
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-pin icons"></i
                ><span class="name">pin</span> .icon-pin
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-picture icons"></i
                ><span class="name">picture</span> .icon-picture
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-handbag icons"></i
                ><span class="name">handbag</span> .icon-handbag
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-globe-alt icons"></i
                ><span class="name">globe-alt</span> .icon-globe-alt
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-globe icons"></i
                ><span class="name">globe</span> .icon-globe
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-folder-alt icons"></i
                ><span class="name">folder-alt</span> .icon-folder-alt
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-folder icons"></i
                ><span class="name">folder</span> .icon-folder
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-film icons"></i
                ><span class="name">film</span> .icon-film
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-feed icons"></i
                ><span class="name">feed</span> .icon-feed
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-drop icons"></i
                ><span class="name">drop</span> .icon-drop
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-drawer icons"></i
                ><span class="name">drawer</span> .icon-drawer
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-docs icons"></i
                ><span class="name">docs</span> .icon-docs
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-doc icons"></i
                ><span class="name">doc</span> .icon-doc
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-diamond icons"></i
                ><span class="name">diamond</span> .icon-diamond
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-cup icons"></i
                ><span class="name">cup</span> .icon-cup
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-calculator icons"></i
                ><span class="name">calculator</span> .icon-calculator
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-bubbles icons"></i
                ><span class="name">bubbles</span> .icon-bubbles
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-briefcase icons"></i
                ><span class="name">briefcase</span> .icon-briefcase
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-book-open icons"></i
                ><span class="name">book-open</span> .icon-book-open
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-basket-loaded icons"></i
                ><span class="name">basket-loaded</span> .icon-basket-loaded
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-basket icons"></i
                ><span class="name">basket</span> .icon-basket
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-bag icons"></i
                ><span class="name">bag</span> .icon-bag
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-action-undo icons"></i
                ><span class="name">action-undo</span> .icon-action-undo
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-action-redo icons"></i
                ><span class="name">action-redo</span> .icon-action-redo
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-wrench icons"></i
                ><span class="name">wrench</span> .icon-wrench
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-umbrella icons"></i
                ><span class="name">umbrella</span> .icon-umbrella
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-trash icons"></i
                ><span class="name">trash</span> .icon-trash
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-tag icons"></i
                ><span class="name">tag</span> .icon-tag
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-support icons"></i
                ><span class="name">support</span> .icon-support
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-frame icons"></i
                ><span class="name">frame</span> .icon-frame
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-size-fullscreen icons"></i
                ><span class="name">size-fullscreen</span> .icon-size-fullscreen
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-size-actual icons"></i
                ><span class="name">size-actual</span> .icon-size-actual
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-shuffle icons"></i
                ><span class="name">shuffle</span> .icon-shuffle
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-share-alt icons"></i
                ><span class="name">share-alt</span> .icon-share-alt
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-share icons"></i
                ><span class="name">share</span> .icon-share
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-rocket icons"></i
                ><span class="name">rocket</span> .icon-rocket
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-question icons"></i
                ><span class="name">question</span> .icon-question
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-pie-chart icons"></i
                ><span class="name">pie-chart</span> .icon-pie-chart
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-pencil icons"></i
                ><span class="name">pencil</span> .icon-pencil
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-note icons"></i
                ><span class="name">note</span> .icon-note
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-loop icons"></i
                ><span class="name">loop</span> .icon-loop
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-home icons"></i
                ><span class="name">home</span> .icon-home
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-grid icons"></i
                ><span class="name">grid</span> .icon-grid
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-graph icons"></i
                ><span class="name">graph</span> .icon-graph
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-microphone icons"></i
                ><span class="name">microphone</span> .icon-microphone
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-music-tone-alt icons"></i
                ><span class="name">music-tone-alt</span> .icon-music-tone-alt
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-music-tone icons"></i
                ><span class="name">music-tone</span> .icon-music-tone
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-earphones-alt icons"></i
                ><span class="name">earphones-alt</span> .icon-earphones-alt
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-earphones icons"></i
                ><span class="name">earphones</span> .icon-earphones
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-equalizer icons"></i
                ><span class="name">equalizer</span> .icon-equalizer
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-like icons"></i
                ><span class="name">like</span> .icon-like
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-dislike icons"></i
                ><span class="name">dislike</span> .icon-dislike
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-start icons"></i
                ><span class="name">control-start</span> .icon-control-start
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-rewind icons"></i
                ><span class="name">control-rewind</span> .icon-control-rewind
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-play icons"></i
                ><span class="name">control-play</span> .icon-control-play
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-pause icons"></i
                ><span class="name">control-pause</span> .icon-control-pause
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-forward icons"></i
                ><span class="name">control-forward</span> .icon-control-forward
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-control-end icons"></i
                ><span class="name">control-end</span> .icon-control-end
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-volume-1 icons"></i
                ><span class="name">volume-1</span> .icon-volume-1
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-volume-2 icons"></i
                ><span class="name">volume-2</span> .icon-volume-2
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-volume-off icons"></i
                ><span class="name">volume-off</span> .icon-volume-off
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-calendar icons"></i
                ><span class="name">calendar</span> .icon-calendar
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-bulb icons"></i
                ><span class="name">bulb</span> .icon-bulb
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-chart icons"></i
                ><span class="name">chart</span> .icon-chart
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-ban icons"></i
                ><span class="name">ban</span> .icon-ban
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-bubble icons"></i
                ><span class="name">bubble</span> .icon-bubble
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-camrecorder icons"></i
                ><span class="name">camrecorder</span> .icon-camrecorder
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-camera icons"></i
                ><span class="name">camera</span> .icon-camera
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-cloud-download icons"></i
                ><span class="name">cloud-download</span> .icon-cloud-download
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-cloud-upload icons"></i
                ><span class="name">cloud-upload</span> .icon-cloud-upload
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-envelope icons"></i
                ><span class="name">envelope</span> .icon-envelope
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-eye icons"></i
                ><span class="name">eye</span> .icon-eye
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-flag icons"></i
                ><span class="name">flag</span> .icon-flag
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-heart icons"></i
                ><span class="name">heart</span> .icon-heart
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-info icons"></i
                ><span class="name">info</span> .icon-info
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-key icons"></i
                ><span class="name">key</span> .icon-key
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-link icons"></i
                ><span class="name">link</span> .icon-link
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-lock icons"></i
                ><span class="name">lock</span> .icon-lock
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-lock-open icons"></i
                ><span class="name">lock-open</span> .icon-lock-open
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-magnifier icons"></i
                ><span class="name">magnifier</span> .icon-magnifier
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-magnifier-add icons"></i
                ><span class="name">magnifier-add</span> .icon-magnifier-add
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-magnifier-remove icons"></i
                ><span class="name">magnifier-remove</span>
                .icon-magnifier-remove
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-paper-clip icons"></i
                ><span class="name">paper-clip</span> .icon-paper-clip
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-paper-plane icons"></i
                ><span class="name">paper-plane</span> .icon-paper-plane
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-power icons"></i
                ><span class="name">power</span> .icon-power
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-refresh icons"></i
                ><span class="name">refresh</span> .icon-refresh
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-reload icons"></i
                ><span class="name">reload</span> .icon-reload
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-settings icons"></i
                ><span class="name">settings</span> .icon-settings
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-star icons"></i
                ><span class="name">star</span> .icon-star
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-symbol-female icons"></i
                ><span class="name">symbol-female</span> .icon-symbol-female
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-symbol-male icons"></i
                ><span class="name">symbol-male</span> .icon-symbol-male
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-target icons"></i
                ><span class="name">target</span> .icon-target
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-credit-card icons"></i
                ><span class="name">credit-card</span> .icon-credit-card
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-paypal icons"></i
                ><span class="name">paypal</span> .icon-paypal
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-tumblr icons"></i
                ><span class="name">social-tumblr</span> .icon-social-tumblr
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-twitter icons"></i
                ><span class="name">social-twitter</span> .icon-social-twitter
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-facebook icons"></i
                ><span class="name">social-facebook</span> .icon-social-facebook
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-instagram icons"></i
                ><span class="name">social-instagram</span>
                .icon-social-instagram
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-linkedin icons"></i
                ><span class="name">social-linkedin</span> .icon-social-linkedin
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-pinterest icons"></i
                ><span class="name">social-pinterest</span>
                .icon-social-pinterest
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-github icons"></i
                ><span class="name">social-github</span> .icon-social-github
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-google icons"></i
                ><span class="name">social-google</span> .icon-social-google
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-reddit icons"></i
                ><span class="name">social-reddit</span> .icon-social-reddit
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-skype icons"></i
                ><span class="name">social-skype</span> .icon-social-skype
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-dribbble icons"></i
                ><span class="name">social-dribbble</span> .icon-social-dribbble
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-behance icons"></i
                ><span class="name">social-behance</span> .icon-social-behance
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-foursqare icons"></i
                ><span class="name">social-foursqare</span>
                .icon-social-foursqare
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-soundcloud icons"></i
                ><span class="name">social-soundcloud</span>
                .icon-social-soundcloud
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-spotify icons"></i
                ><span class="name">social-spotify</span> .icon-social-spotify
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-stumbleupon icons"></i
                ><span class="name">social-stumbleupon</span>
                .icon-social-stumbleupon
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-youtube icons"></i
                ><span class="name">social-youtube</span> .icon-social-youtube
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-dropbox icons"></i
                ><span class="name">social-dropbox</span> .icon-social-dropbox
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-vkontakte icons"></i
                ><span class="name">social-vkontakte</span>
                .icon-social-vkontakte
              </div>
            </div>
            <div class="font-icon-list p-2 border all mx-1 mb-2">
              <div class="preview">
                <i class="icon-social-steam icons"></i
                ><span class="name">social-steam</span> .icon-social-steam
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
